// Schema field type for datasource request/response schemas

export interface SchemaField {
  name: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array'
  required?: boolean
  children?: SchemaField[]  // for type: 'object'
  items?: SchemaField       // for type: 'array' (uniform item schema)
}

export type SchemaFieldType = SchemaField['type']

export const SCHEMA_FIELD_TYPES: SchemaFieldType[] = ['string', 'number', 'boolean', 'object', 'array']
